module.exports = __webpack_public_path__ + "img/i45.15e267ac.png";